import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App.tsx";
import "./index.css";

// Initialize PostHog early (before React renders)
import { initPostHog } from "./lib/posthog";
initPostHog();

// Handle stale chunk errors from cached builds referencing old JS chunks.
// When Vite's preload fails, reload once to fetch the latest chunks.
window.addEventListener('vite:preloadError', () => {
  const hasReloaded = sessionStorage.getItem('chunk-reload');
  if (!hasReloaded) {
    sessionStorage.setItem('chunk-reload', '1');
    window.location.reload();
  }
});

// Clear the reload guard on successful page load so future deploys can also reload
window.addEventListener('load', () => {
  sessionStorage.removeItem('chunk-reload');
});

createRoot(document.getElementById("root")!).render(
  <HelmetProvider>
    <App />
  </HelmetProvider>
);
